module.exports = "js/webpack/16df1af03b096dc9d1593b592e8ce3cf.png";